<template>
  <div class="letter__wrap">
    <div class="letter-title__wrap">
      <h4>추모의 글</h4>
      <div class="letter-icon__wrap" @click="$emit('handleViewLetter')">
        <h4>전체보기</h4>
        <v-icon>mdi-chevron-right</v-icon>
      </div>
    </div>
    <div class="msg-card">
      <div
        v-for="(obituaryMessage, i) in limitedObituaryMessages"
        :key="i"
        class="message-item"
      >
        <v-sheet height="100%">
          <div class="d-flex align-center mt-4 ml-4 mb-4 mr-4">
            <div style="width: 100%">
              <h6 class="line-clamp d-flex">
                {{ obituaryMessage.messageName }}
                <v-spacer></v-spacer>
                <button
                  v-if="obituaryMessage.messagePassword"
                  @click="handleEditFlag(obituaryMessage)"
                  class="edit-button"
                >
                  <img src="@/assets/images/obituary/edit.svg" alt="Edit" />
                </button>
              </h6>
              <p>
                {{ obituaryMessage.messageContent }}
              </p>
            </div>
          </div>
        </v-sheet>
      </div>
    </div>
    <button class="msg-button" @click="$emit('handleRegistLetter')">
      글쓰기
    </button>
    <!-- You may need to implement the modal here -->
  </div>
</template>

<script>
export default {
  name: "ObituaryLetter",
  props: ["obituaryMessages"],
  data() {
    return {};
  },
  computed: {
    limitedObituaryMessages() {
      if (this.obituaryMessages) {
        return [...this.obituaryMessages].reverse().slice(0, 3);
      }

      return [];
    }
  },
  methods: {
    handleEditFlag(obituaryComment) {
      this.$emit("handleEditFlag", obituaryComment);
    }
  }
};
</script>

<style>
.letter__wrap .theme--light.v-sheet {
  background-color: transparent !important;
}
</style>
